export default {"src":"/_next/static/media/registration.9f3eb2e2.svg","height":357,"width":422,"blurWidth":0,"blurHeight":0};